import React from "react";

const badgeStyle = {
  display: "inline-block",
  backgroundColor: "#007bff",
  color: "white",
  padding: "6px 12px",
  margin: "5px 8px 5px 0",
  borderRadius: "20px",
  fontSize: "0.9rem",
  fontWeight: "600",
  userSelect: "none",
};

export default function About() {
  const technicalSkills = [
    "Ruby on Rails",
    "React",
    "JavaScript",
    "Databases",
    "Google Cloud Platform (GCP)",
    "AWS",
  ];

  const teachingSkills = [
    "C",
    "C++",
    "Java",
    ".NET",
    "HTML",
    "CSS",
    "JavaScript",
    "React",
  ];

  return (
    <section id="about">
      <h2>About Harpreet Singh</h2>

      <p>
        Harpreet Singh is a Project Manager and Software Developer with over
        14 years of experience in software development, project management,
        technology leadership, and delivering software solutions.
      </p>

      <p>
        Throughout his career, he has worked across software development,
        project delivery, team leadership, and enterprise technology. His
        technical experience includes Ruby on Rails, React, JavaScript,
        databases, cloud platforms, and modern web applications.
      </p>

      <h3>Technical Expertise</h3>

      <div>
        {technicalSkills.map((skill, index) => (
          <span key={index} style={badgeStyle}>
            {skill}
          </span>
        ))}
      </div>

      <h3>Teaching Expertise</h3>

      <div>
        {teachingSkills.map((skill, index) => (
          <span key={index} style={badgeStyle}>
            {skill}
          </span>
        ))}
      </div>
    </section>
  );
}
